import React, { useCallback, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import ErrorPage from "./ErrorPage";
import Graph from "./Graph";
import Loading from "./Loading";
// Markets.css file

const fetchAnalysisData = async (instrumentId) => {
  try {
    const url = new URL(
      `https://assets.msn.com/service/Finance/Equities?apikey=0QfOX3Vn51YCzitbLaRkTTBadtWpgTN8NZLW0C1SEM&activityId=3C66B9F9-4495-4689-85E2-1505A80E3D0C&ocid=finance-utils-peregrine&cm=en-in&it=web&ids=${instrumentId}&wrapodata=false`
    );
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const json = await response.json();
    return json;
  } catch (error) {
    console.error("Network Error", error);
    throw error;
  }
};

const fetchCompanyData = async (instrumentId) => {
  try {
    const url = new URL(
      `https://assets.msn.com/service/Finance/Quotes?apikey=0QfOX3Vn51YCzitbLaRkTTBadtWpgTN8NZLW0C1SEM&activityId=3C66B9F9-4495-4689-85E2-1505A80E3D0C&ocid=finance-utils-peregrine&cm=en-in&it=web&ids=${instrumentId}&wrapodata=false`
    );
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const json = await response.json();
    return json;
  } catch (error) {
    console.error("Network Error", error);
    throw error;
  }
};

const CompanyData = () => {
  const location = useLocation();
  const [instrumentId, setinstrumentId] = useState(
    location.pathname.substring(location.pathname.length - 6)
  );
  const [summaryData, setSummaryData] = useState(null);
  const [companyData, setCompanyData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);

  const fetchBothData = useCallback(() => {
    setIsLoading(true);
    setinstrumentId(location.pathname.substring(location.pathname.length - 6));
    Promise.all([
      fetchAnalysisData(instrumentId),
      fetchCompanyData(instrumentId),
    ])
      .then(([analysisData, companyData]) => {
        setSummaryData(analysisData);
        setCompanyData(companyData);
      })
      .catch((err) => {
        setIsError(true);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [location.pathname, instrumentId]);

  useEffect(() => {
    fetchBothData();
    const intervalId = setInterval(() => fetchBothData(), 60000);
    return () => clearInterval(intervalId);
  }, [fetchBothData]);

  function formatVolume(volume) {
    if (volume >= 1000000000) {
      return (volume / 1000000000).toFixed(2) + "B";
    } else if (volume >= 1000000) {
      return (volume / 1000000).toFixed(2) + "M";
    } else {
      return volume.toString();
    }
  }

  if (isError) {
    return <ErrorPage />;
  }
  if (isLoading) {
    return <Loading />;
  }

  return (
    <>
      <div className="market_dashboard">
        <div className="market_dashboard_title">
          <strong>
            <Link to="/" className="link_path">
              Home
            </Link>{" "}
            &gt;{" "}
            <Link to="/markets" className="link_path">
              Market
            </Link>{" "}
            &gt; Company
          </strong>
          <h2 style={{ marginTop: "20px" }}>{summaryData[0].company.name}</h2>
        </div>
        <div className="market_dashboard_cards">
          <Link className="nav_link">
            <div className="dashboard_card">Global Market</div>
          </Link>
          <Link className="nav_link">
            <div className="dashboard_card">Most Active</div>
          </Link>
          <Link className="nav_link">
            <div className="dashboard_card">Top Gainers</div>
          </Link>
          <Link className="nav_link">
            <div className="dashboard_card">Top Losers</div>
          </Link>
        </div>
      </div>

      <div className="dashboard_data_container">
        <div className="chart_container mr1">
          <div className="graph_container">
            <Graph instrumentId={instrumentId} />
          </div>
          <div className="card_container">
            <div className="market_cards">
              <div className="market_card">
                <h6>Previous Close</h6>
                <h5>{companyData[0].pricePreviousClose}</h5>
              </div>

              <div className="market_card">
                <h6>Average Volume</h6>
                <h5>{formatVolume(companyData[0].averageVolume)}</h5>
              </div>

              <div className="market_card">
                <h6>Market Cap</h6>
                <h5>{formatVolume(companyData[0].marketCap)}</h5>
              </div>

              <div className="market_card">
                <h6>Day Range</h6>
                <h5>
                  {companyData[0].priceDayLow} {" - "}
                  {companyData[0].priceDayHigh}
                </h5>
              </div>

              <div className="market_card">
                <h6>52 Week Range</h6>
                <h5>
                  {companyData[0].price52wLow}
                  {" - "}
                  {companyData[0].price52wHigh}
                </h5>
              </div>

              <div className="market_card">
                <h6>Shares Outstanding</h6>
                <h5>
                  {formatVolume(
                    summaryData[0].analysis.shareStatistics.sharesOutstanding
                  )}
                </h5>
              </div>

              <div className="market_card">
                <h6>EPS (TTM)</h6>
                <h5>{summaryData[0].analysis.keyMetrics.eps}</h5>
              </div>

              <div className="market_card">
                <h6>P/E (TTM)</h6>
                <h5>{companyData[0].peRatio}</h5>
              </div>

              <div
                className="market_card"
                style={{
                  display: summaryData[0].analysis.companyMetrics.dividendYield
                    ? "block"
                    : "none",
                }}
              >
                <h6>Fwd Dividend (%Yield)</h6>
                <h5>
                  {summaryData[0].analysis.companyMetrics.dividendYield}{" "}
                  <span
                    style={{
                      display: summaryData[0].analysis.companyMetrics
                        .forwardDividendYield
                        ? "block"
                        : "none",
                    }}
                  >
                    {"(" +
                      summaryData[0].analysis.companyMetrics
                        .forwardDividendYield +
                      ")"}
                  </span>
                </h5>
              </div>
            </div>
          </div>
        </div>
        <div className="chart_container ml1">
          <div className="dd_container">
            <h4>Company Profile</h4>
          </div>
          <div>
            {companyData === null ? (
              "loading..."
            ) : (
              <div className="analysis_data_container">
                <span>{summaryData[0].company.description}</span>
                <div className="company_profile_data">
                  <div className="profile_card_data">
                    <span>Incorporated</span>
                    <h6>{summaryData[0].company.establishedYear}</h6>
                  </div>
                  <div className="profile_card_data">
                    <span>Sector</span>
                    <h6>{summaryData[0].company.sector}</h6>
                  </div>
                  <div className="profile_card_data">
                    <span>Industry</span>
                    <h6>{summaryData[0].company.industry}</h6>
                  </div>
                  <div className="profile_card_data">
                    <span>Employees</span>
                    <h6>{summaryData[0].company.employees}</h6>
                  </div>
                  <div className="profile_card_data">
                    <span>Website</span>
                    <Link
                      style={{ textDecoration: "none" }}
                      to={summaryData[0].company.website}
                      target="_blank"
                    >
                      <h6>{summaryData[0].company.website}</h6>
                    </Link>
                  </div>
                </div>
                <div className="profile_card_data">
                  <span>Address</span>
                  <h6>
                    {"Street : "}
                    {summaryData[0].company.address.street.replace(
                      /,{2,}/g,
                      ","
                    )}
                  </h6>
                  <h6>
                    {"City : "}
                    {summaryData[0].company.address.city}
                  </h6>
                  <h6>
                    {"State : "}
                    {summaryData[0].company.address.state}
                  </h6>
                  <h6>
                    {"Zip : "}
                    {summaryData[0].company.address.zip}
                  </h6>
                  <h6>
                    {"Country : "}
                    {summaryData[0].company.address.country}
                  </h6>
                  <h6>
                    {"Country Code : "}
                    {summaryData[0].company.address.countryCode}
                  </h6>
                  <h6
                    style={{
                      display: summaryData[0].company.address.phone
                        ? "block"
                        : "none",
                    }}
                  >
                    {"Phone : "}
                    {summaryData[0].company.address.phone}
                  </h6>
                  <h6
                    style={{
                      display: summaryData[0].company.address.fax
                        ? "block"
                        : "none",
                    }}
                  >
                    {"Fax : "}
                    {summaryData[0].company.address.fax}
                  </h6>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default CompanyData;
